const production = "https://securedapi.confirmtkt.com";
// const staging = "https://irctc-staging.confirmtkt.com";

const POPULAR_CITIES = [
  { masterId: 13713, value: "MUMBAI, MAHARASHTRA" },
  { masterId: 10636, value: "BENGALURU, KARNATAKA" },
  { masterId: 12049, value: "HYDERABAD, TELANGANA" },
  { masterId: 11036, value: "CHENNAI, TAMIL NADU" },
  { value: "NEW DELHI, DELHI", masterId: 13982 },
  { value: "AHMEDABAD, GUJARAT", masterId: 10055 },
  { value: "KOLKATA, WEST BENGAL", masterId: 12847 },
  { value: "PUNE, MAHARASHTRA", masterId: 14499 },
  { value: "SURAT, GUJARAT", masterId: 15353 },
  { value: "KOCHI, KERALA", masterId: 12806 }
];

export const Config = {
  SECURED_API_HOST: production,
  POPULAR_CITIES: POPULAR_CITIES
};
